import { api } from "./api";
import { NotifyModelKey } from "./api";
import { renderNotifyEmailField } from "./generics";

// Mały, wspólny "doczep e-mail po fakcie" widżet - pokazywany PO udanym dodaniu uczelni/wydziału/
// wykładowcy/przedmiotu (zawsze czekają na moderację), albo po komentarzu/przedmiocie wstępnie
// odrzuconym przez AI (patrz comments.ts/addLecturer.ts/landing2.ts). Obiekt jest już zapisany w
// bazie w tym momencie - ten widżet tylko DOPINA doń opcjonalny e-mail (patrz SetNotifyEmailView
// w backendzie), zamiast pytać o niego z góry w głównym formularzu.
//
// Domyślnie schowany za linkiem "tutaj" w krótkim zdaniu (mniejszą czcionką) - dopiero kliknięcie
// rozwija pole e-mail i przyciski. Mniej nachalne niż od razu widoczny formularz z dwoma
// przyciskami, a jednocześnie nie trzeba osobnego "Nie, dziękuję" w stanie zwiniętym - to
// pojedyncze zdanie samo w sobie jest łatwe do zignorowania.
//
// onResolved (opcjonalny) - odpala się, gdy user faktycznie SKOŃCZYŁ z widżetem (podał e-mail
// albo kliknął "Anuluj"), NIGDY na podstawie samego czasu - patrz addLecturer.ts, gdzie
// wcześniej wołający odpalał odświeżenie listy na sztywnym timerze (8s) niezależnie od tego, czy
// user właśnie wpisywał e-mail (zgłoszenie: "mimo że wpisuję e-mail, to pole się chowa po chwili").
//
// targets - zwykle jeden obiekt, ale np. w comments.ts komentarz i przy okazji dodany przedmiot
// czekają na moderację RAZEM - jeden e-mail user podaje raz, a widżet dopina go do WSZYSTKICH
// targetów (osobne wywołania API, patrz confirmBtn niżej), zamiast pokazywać dwa identycznie
// wyglądające widżety obok siebie (zgłoszenie: "po dodaniu komentarza renderuje się dwa razy prompt").
export function renderPostHocNotifyPrompt(
    targets: { model: NotifyModelKey; pk: number }[],
    onResolved?: () => void,
): HTMLElement {
    const wrapper = document.createElement("div");
    wrapper.className = "notify-email-followup";

    const introText = document.createElement("p");
    introText.className = "notify-email-followup-intro";
    const expandLink = document.createElement("button");
    expandLink.type = "button";
    expandLink.className = "notify-email-followup-link";
    expandLink.textContent = "tutaj";
    introText.append(
        "Możesz ", expandLink, " zostawić swój adres e-mail, abyśmy poinformowali Cię o decyzji.",
    );

    const expandSection = document.createElement("div");
    expandSection.className = "notify-email-followup-expand";
    expandSection.hidden = true;

    const notifyEmailField = renderNotifyEmailField();

    const confirmBtn = document.createElement("button");
    confirmBtn.type = "button";
    confirmBtn.className = "add-comment-btn";
    confirmBtn.textContent = "Powiadom mnie";

    // Jawna rezygnacja - obok "Powiadom mnie", żeby dało się świadomie zamknąć rozwinięty widżet
    // zamiast zostawiać go widocznym bezterminowo (patrz brak automatycznego chowania niżej w
    // landing2.ts/addLecturer.ts - to jedyny sposób, żeby się go pozbyć poza faktycznym podaniem
    // maila).
    const cancelBtn = document.createElement("button");
    cancelBtn.type = "button";
    cancelBtn.className = "notify-email-followup-dismiss";
    cancelBtn.textContent = "Anuluj";
    cancelBtn.addEventListener("click", () => {
        wrapper.replaceChildren();
        onResolved?.();
    });

    const actions = document.createElement("div");
    actions.className = "notify-email-followup-actions";
    actions.append(confirmBtn, cancelBtn);

    const feedback = document.createElement("span");
    feedback.className = "notify-email-followup-feedback";

    expandLink.addEventListener("click", () => {
        introText.hidden = true;
        expandSection.hidden = false;
        notifyEmailField.element.querySelector("input")?.focus();
    });

    confirmBtn.addEventListener("click", async () => {
        const email = notifyEmailField.getValue();
        if (!email) {
            feedback.textContent = "Podaj adres e-mail.";
            return;
        }
        confirmBtn.disabled = true;
        feedback.textContent = "";

        const results = await Promise.all(
            targets.map(({ model, pk }) => api.setNotifyEmail(model, pk, email)),
        );
        const failed = results.find((res) => !res.ok);

        if (!failed) {
            wrapper.replaceChildren();
            const done = document.createElement("span");
            done.className = "notify-email-followup-done";
            done.textContent = "Dziękujemy, powiadomimy Cię mailem o decyzji.";
            wrapper.appendChild(done);
            onResolved?.();
        } else {
            confirmBtn.disabled = false;
            feedback.textContent = `Błąd: ${failed.error}`;
        }
    });

    expandSection.append(notifyEmailField.element, actions, feedback);
    wrapper.append(introText, expandSection);
    return wrapper;
}
